import React from "react";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/ionicons/close";
import AlertBox from "../../common/UI/AlertBox/AlertBox";
import successIcon from "../../../assets/images/Sucsess.png";
import "../../../assets/css/components/Modal/Modal.css";

const SuccessModal = (props) => {
  const { modalVisibility, modalLabel, closeModalHandler, modalClass, messageContent, doneBtnId } = props;
  return (
    <AlertBox
      alertVisibility={modalVisibility}
      closeAlertBoxHandler={closeModalHandler}
      backdrop={false}
      alertLabel={modalLabel}
      alertClass={modalClass}
    >
      <div className="modal-wrapper">
        <div className="text-right">
          <span onClick={closeModalHandler}>
            <Icon size={20} icon={close} />
          </span>
        </div>
        <div className="text-center mar">
          <img src={successIcon} alt="Success" />
        </div>
        <p className="content-modal text-center">
          Message
                <br />
          <a className="btn btn-link">{messageContent}</a>
        </p>
        <div className={"text-center"}>
          <button
            onClick={closeModalHandler}
            type="button"
            className="btn btn-org"
            id={doneBtnId}
          >
            Done
                </button>
        </div>
      </div>
    </AlertBox>
  );
}

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/common/SuccessModal/SuccessModal.jsx